
export default function VisualIdentity() {
  return (
    <section className="bg-[#1C1C1E] py-32">
      <div className="max-w-6xl mx-auto px-8">
        <div className="text-center mb-20">
          <h2 className="font-serif text-4xl md:text-5xl text-[#F7F5F2] mb-8">
            A visual identity grounded in legal authority
          </h2>
          <p className="text-xl text-[#8A8F98] max-w-3xl mx-auto leading-relaxed">
            carfuagency's identity system reflects precision, stability, and professional excellence—designed to align with the standards of modern law firms.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-16">
          <div className="text-center">
            <div className="bg-[#0E1A2B] p-12 mb-6 flex items-center justify-center h-64">
              <img 
                src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/587d4bfe7b2d3053bc3f394890cbc68c.png" 
                alt="Legal Crest Mark" 
                className="h-32 w-auto object-contain"
              />
            </div>
            <h4 className="text-[#F7F5F2] font-semibold text-lg mb-2">Legal Crest Mark</h4>
            <p className="text-[#8A8F98] text-sm">Primary brand symbol</p>
          </div>
          
          <div className="text-center">
            <div className="bg-[#F7F5F2] p-12 mb-6 flex items-center justify-center h-64">
              <img 
                src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/587d4bfe7b2d3053bc3f394890cbc68c.png" 
                alt="Precision Wordmark" 
                className="h-32 w-auto object-contain"
              />
            </div>
            <h4 className="text-[#F7F5F2] font-semibold text-lg mb-2">Precision Wordmark</h4>
            <p className="text-[#8A8F98] text-sm">Typography-focused identity</p>
          </div>
          
          <div className="text-center">
            <div className="bg-[#0E1A2B] p-12 mb-6 flex items-center justify-center h-64">
              <div className="text-[#C8A14A]">
                <i className="ri-building-line text-8xl"></i>
              </div>
            </div>
            <h4 className="text-[#F7F5F2] font-semibold text-lg mb-2">Pillar Mark</h4>
            <p className="text-[#8A8F98] text-sm">Structural foundation symbol</p>
          </div>
        </div>
      </div>
    </section>
  );
}
